import React from 'react';
import ReactDOM from 'react-dom';
import { Basket, BasketButton } from '..';
import './navigation-footer.scss';

export default function NavigationFooter({
  onBack,
  onNext,
  onCancel,
  nextEnabled,
  hideCancel,
  nextButtonLabel,
  backButtonLabel,
  hideBack,
  hideNext,
  automationIdPrefix,
  showBasketIcon,
  showBasket,
  setShowBasket,
  isBasketMiniMode,
  customerType = 'normal',
}) {
  const backButton = () =>
    !hideBack && (
      <button
        automationid={`${automationIdPrefix}_Button_Back`}
        className={`button is-secondary is-rounded`}
        onClick={() => onBack()}
      >
        {backButtonLabel || 'Back'}
      </button>
    );

  const cancelButton = () =>
    !hideCancel && (
      <a
        automationid={`${automationIdPrefix}_Link_Cancel`}
        className="is-text-link has-text-red has-margin-x-5"
        onClick={() => onCancel()}
      >
        Cancel
      </a>
    );

  const nextButton = (isMobile = false) =>
    !hideNext && (
      <button
        automationid={`${automationIdPrefix}_Button_Next`}
        className={`button is-primary is-rounded ${isMobile ? 'is-fullwidth' : ''}`}
        onClick={() => onNext()}
        disabled={!nextEnabled}
      >
        {nextButtonLabel || 'Next'}
      </button>
    );

  // this renders a component to the element with id 'above-all' in index.html using a React Portal
  const renderToAboveAllPortal = (component) =>
    ReactDOM.createPortal(component, document.getElementById('above-all'));

  return (
    <div className={`NavigationFooter ${!hideCancel && 'higher-footer'}`}>
      <div className="footer-navigation level show-desktop-only">
        <div className="level-left">
          <div className="level-item">{backButton()}</div>
        </div>
        {showBasketIcon && (
          <BasketButton showBasket={setShowBasket} isMobile={false} customerType={customerType} />
        )}
        <div className="level-right">
          <div className="level-item">{cancelButton()}</div>
          <div className="level-item">{nextButton()}</div>
        </div>
      </div>

      {showBasket &&
        renderToAboveAllPortal(<Basket showBasket={setShowBasket} miniMode={isBasketMiniMode()} />)}

      <div className="footer-navigation show-mobile-only is-mobile buttons">
        <div className="container field">
          <div className="columns is-mobile">
            {showBasketIcon && (
              <div className={'column is-one-thirds'}>
                <BasketButton showBasket={setShowBasket} isMobile={true} />
              </div>
            )}
            <div className={`column ${showBasketIcon ? 'is-two-thirds' : 'is-full'}`}>
              {nextButton(true)}
            </div>
          </div>
          {!hideCancel && <div className="has-padding-top-7 level-item">{cancelButton()}</div>}
        </div>
      </div>
    </div>
  );
}
